import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, useMap, Popup, Marker } from "react-leaflet";
import { Icon } from "leaflet";
import { faRetweet } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import "leaflet/dist/leaflet.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Map() {
  const { proxy, lang } = useSelector((state) => state);
  const _token = localStorage.getItem("_token");
  const [isLoading, setLoading] = useState(false);

  const [refreshPage, setRefreshPage] = useState(0);
  const defaultLocation = [16.585458405137977, 111.62310562834635];
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = () => {
      setLoading(true);
      fetch(`${proxy()}/api/map`, {
        method: "GET",
        headers: {
          Authorization: _token,
          "content-type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);
          setData(res);
        });
    };
    fetchData();
  }, []);


  return (
    <div key={refreshPage} style={{ margin: "5px -15px" }}>
      <div className="white_shd full">
        <div
          className="tabbar padding_infor_info_p-d-5"
          style={{ padding: "0px", minHeight: "92vh" }}
        >
          <div style={{ margin: "0px", padding: "6px 12px", width: "100%" }}>
            <div class="d-flex align-items-center page-title position-relative mb-0">
              <span style={{ fontSize: "18px" }}></span>
              <div class="ml-auto d-flex align-items-center">
                <FontAwesomeIcon
                  icon={faRetweet}
                  onClick={() => {
                    setRefreshPage((prev) => prev + 1);
                  }}
                  className="icon-add mr-2 pointer"
                  title={lang["Refesh"]}
                  style={{ fontSize: "27px", color: "#e0762a" }}
                />
              </div>
            </div>
            <hr
              style={{
                border: "1px solid rgb(221, 221, 221)",
                margin: "0px -12px 5px -12px",
              }}
            />
            <div className="table-display d-flex">
              <div className="table-responsive table-custom design-table mt-1">
                {/* <iframe
                  style={{
                    height: "100%",
                    width: "100%",
                  }}
                  frameborder="0"
                  src="https://www.google.com/maps/embed/v1/place?q=Khu+Công+Nghiệp+Long+Đức&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
                ></iframe> */}

                <MapContainer
                  center={defaultLocation}
                  zoom={7}
                  scrollWheelZoom={true}
                  attributionControl={false}
                >
                  <TileLayer
                    // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  <Marker position={defaultLocation}>
                            <Popup>aaa</Popup>
                          </Marker>
                  {data &&
                    data.length > 0 &&
                    data.map((item) => {
                      const position = [item.lat, item.long];
                      const customeIcon = new Icon({
                        iconUrl:
                          item.NoiDung === "error"
                            ? "/images/location-pin-error.png"
                            : "/images/location-pin.png",
                        iconSize: [30, 30],
                      });
                      return (
                        item.NoiDung !== "error" && (
                          <Marker position={position} icon={customeIcon}>
                            <Popup>{item.TieuDe}</Popup>
                          </Marker>
                        )
                      );
                    })}
                </MapContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
